<div class="px-4 mt-24 min-h-screen">
  <main class="w-full max-w-lg mx-auto" data-purpose="consent-pending-wrapper">
    <section
      class="daisy-card bg-base-100 rounded-2xl shadow-xl border border-base-200 p-8 md:p-12 text-center"
      data-purpose="status-card"
    >
      <div
        class="mb-8 flex justify-center"
        data-purpose="waiting-icon-container"
      >
        <div class="relative">
          <div class="bg-primary/10 p-6 rounded-full">
            <svg
              class="h-16 w-16 text-primary"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </div>
          <!-- Small overlay clock icon for 'pending' state -->
          <div
            class="absolute -bottom-1 -right-1 bg-base-100 p-1 rounded-full border-2 border-primary/20"
          >
            <svg
              class="h-6 w-6 text-warning"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </div>
        </div>
      </div>

      <h1
        class="text-2xl md:text-3xl font-semibold text-base-content mb-6 tracking-tight"
      >
        Parent/Guardian Consent Pending
      </h1>

      <div class="space-y-4 mb-10">
        <p class="text-base-content/70 leading-relaxed">
          We have sent an email to your parent or guardian to ask for their
          permission to create this account.
        </p>
        <p class="text-base-content/80 leading-relaxed font-medium">
          You will be able to access your account once they approve the request.
        </p>
      </div>

      <div class="flex flex-col items-center">
        <a
          class="daisy-btn daisy-btn-primary w-full sm:w-auto px-8 shadow-lg shadow-primary/30"
          data-purpose="primary-cta"
          routerLink="/"
        >
          Go to Homepage
        </a>
      </div>
    </section>
  </main>
</div>
